module.exports = {
      id: "menu-search-usage",
      viewBox: "0 0 28.943 16.863",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#menu-search",
      toString: function () {
        return this.url;
      }
    }